<template>
  <div>
    <br />
    <b-tabs class="block" expanded>
      <b-tab-item label="LOGIN">
        <login></login>
      </b-tab-item>
      <b-tab-item label="CREATE AN ACCOUNT">
        <!-- <br />
        <b-field label="Email">
          <b-input type="email" icon="email"></b-input>
        </b-field>
        <br />
        <b-field label="Password">
          <b-input type="password" icon="key"></b-input>
        </b-field>
        <br />
        <b-button label="CREATE ACCOUNT" @click="Submit" type="is-success" expanded>
        </b-button> -->
        <register></register>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
import register from './auth/register.vue'
import login from './auth/login.vue'
export default {
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  components:{
      register,
      login
  },
  data() {
    return {
      isSuccess: false,
      isLoading: false,
      email: '',
      password: '',
      error: '',
      dialog:'',
      isFullPage: true
    };
  },
  methods:{
     ...mapActions(["addMessage", "clearMessage", "loginWithEmail", "registerByEmail"]),
    onSubmit() {
      this.isLoading = true;
      let data = {
        email: this.email,
        password: this.password
      };
      this.loginWithEmail(data)
        .then(() => {
          this.isSuccess = true;
          this.$router.push('/');
        })
        .catch(error => {
          this.loading = false;
          this.error = error.message;
          (this.email = ""), (this.password = "");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    // Submit() {
    //   this.isLoading = true;
    //   let data = {
    //     email: this.email,
    //     password: this.password
    //   };
    //   this.registerByEmail(data)
    //     .then(() => {
    //       const user = this.$fb.auth.currentUser;
    //       const actionCodeSettings = {
    //         url: `${(process.env.VUE_APP_HOST_NAME =
    //           "https://natural-home-of-remedies.web.app")}/sign-in/?email=${
    //             user.email
    //         }`
    //       };
    //       user.sendEmailVerification(actionCodeSettings);
    //       this.dialog = true;
    //     })
    //     .catch(error => {
    //       this.loading = false;
    //       this.error = error.message;
    //     })
    //     .then(() => {
    //       this.isLoading = false;
    //     });
    // }
  }
};
</script>

<style>
</style>
